import { getCookie } from 'src/utils/cookies'

export function getTiktokParams() {
  const ttp = getCookie('_ttp') ?? ''

  return {
    ttp,
  }
}
